import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { InstacartAccountInput } from '@/models/instacartAccount';

export const updateInstacartAccount = async ({ email, data }: { email: string; data: InstacartAccountInput }) => {
  const response = await mutationExecute({
    variables: {
      email,
      data,
    },
    mutation: graphql(`
      mutation UpdateInstacartAccount($email: String!, $data: InstacartAccountInputType!) {
        updateInstacartAccount(email: $email, data: $data) {
          id
          isActive
          isClosed
          isEbtAccount
          user
          email
          phoneNumber
          country
          cookie
          csrfToken
          notes
          lastUsedAt
          lastLoginSuccess
          lastLoginFailure
          isLocked
          lockedAt
          createdAt
          updatedAt
        }
      }
    `),
  });

  return response.data?.updateInstacartAccount!;
};
